module.exports = __webpack_public_path__ + "media/src/img/kid-f73af8d64470c68d3bf220009eef493d.png";